// extracted by mini-css-extract-plugin
export default {"directMessenger":"directMessenger-module__directMessenger___f5Inr","directMessenger__list":"directMessenger-module__directMessenger__list___CQ5Zi"};